import { jsx as _jsx } from "react/jsx-runtime";
import { Typography } from '../Typography/Typography';
import { superEllipseText } from './styles';
const sizesMapping = {
    120: 'h1',
    96: 'h1',
    88: 'h1',
    80: 'h1',
    72: 'h2',
    64: 'h2',
    56: 'h2',
    48: 'h2',
    40: 'headline',
    32: 'body',
    24: 'callout',
    20: 'callout',
    16: 'footnote',
};
export const SuperEllipseText = ({ text, size, className }) => {
    if (!text) {
        return null;
    }
    return (_jsx(Typography, { variant: sizesMapping[size], weight: "medium", className: superEllipseText({ className }), children: text }));
};
